import { Module } from "@/constants";
import { ProjectSubMenu } from "@/modules/projects/components/menu/components/ProjectSubMenu";
import { ProjectStoreSubMenu } from "@/modules/projects/components/menu/components/ProjectStoreSubMenu";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";
import { ProjectService } from "@/modules/projects/service/project";
import { useQuery } from "@tanstack/react-query";
import { ProjectManagersSubMenu } from "@/modules/projects/components/menu/components/ProjectManagersSubMenu";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { Menubar } from "@/components/ui/menubar";

interface ProjectMenuProps {
  projectId?: string;
  className?: string;
}

export const ProjectMenu = ({
  projectId: projectIdFromProps,
  className,
}: ProjectMenuProps) => {
  const projectIdFromHook = useProjectId();
  const projectId = projectIdFromProps ?? projectIdFromHook;
  const projectPermissions = useModulePermissions(Module.Projects);
  const queryProject = () => ProjectService.get(projectId);
  const projectQuery = useQuery({
    queryKey: [Module.Projects, projectId],
    queryFn: queryProject,
  });

  return (
    <Menubar className={className}>
      {projectPermissions.can_update && (
        <ProjectSubMenu projectId={projectId} project={projectQuery.data} />
      )}
      <ProjectStoreSubMenu projectId={projectId} project={projectQuery.data} />
      {projectPermissions.project_managers_read && (
        <ProjectManagersSubMenu projectId={projectId} />
      )}
    </Menubar>
  );
};
